import AppError from "util/AppError";


class StageModuleLogic {
  identificationEventModule; 
  appContext;
  framework;

  constructor(_identificationEventModule,_appContext,_framework) {
    this.identificationEventModule = _identificationEventModule;
    this.appContext = _appContext;
    this.framework = _framework;
  }

  async loginSystemUser(_email,_password,_successCallback,_errorCallback) {    
    let appError = null;
    const response = await this.framework.getAuthenticationSystem().loginSystemUser(_email,_password).catch(error => {
      appError = error;
      console.log(error);
      return null;
    }); 
    console.log(":::::response:::");
    console.log(response);
    try {
      if(response !== null) {
        if(this.framework.isUserAuthenticated()) {
          if(_successCallback !== null) {
            _successCallback("SystemUser login success");
          }        
        }
        else {
          if(_errorCallback !== null) {
            let appError = new AppError("System User not Authenticated","System User not Authenticated","No stackTrace","HomeModuleLogic-5001","NotAuthenticatedException");
            _errorCallback(appError);
          }
        }
      }
      else {
        if(_errorCallback !== null) {
          _errorCallback(appError);
        }      
      }      
    }
    catch(error) {
      console.log(error);
    }
  };    

  async searchForMerchantAccount(merchantAccountId,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchMerchantAccount(merchantAccountId,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }    

  async searchForMerchantProduct(merchantProductId,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchMerchantProduct(merchantProductId,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }  

  async createServiceOrder(serviceorderData,eventType,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const deviceType = this.framework.getDeviceType();
    const deviceId = this.framework.getDeviceId();
    const staffUserId = this.framework.getAuthenticationSystem().getStaffUserId();
    const createServiceOrderRequest = {
      serviceorderData:serviceorderData,
      eventType: eventType,
      deviceType: deviceType,
      deviceId: deviceId,
      staffUserId: staffUserId,
    };    
    const response = await this.framework.getRestSystem().processCreateServiceOrderRequest(createServiceOrderRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }  

  async updateServiceOrderItem(serviceOrderItem,itemStatus,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const deviceType = this.framework.getDeviceType();
    const deviceId = this.framework.getDeviceId();
    const staffUserId = this.framework.getAuthenticationSystem().getStaffUserId();
    const updateServiceOrderItemRequest = {
      serviceOrderItem:serviceOrderItem,
      itemStatus: itemStatus,
      deviceType: deviceType,
      deviceId: deviceId,
      staffUserId: staffUserId,
    };
    const response = await this.framework.getRestSystem().processCreateServiceOrderRequest(updateServiceOrderItemRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }    
  

}


export default StageModuleLogic;